<template>
  <el-form class="imageUploader">
    <el-upload
      class="AddAttachmentButton"
      ref="upload"
      action=""
      :multiple="false"
      :auto-upload="false"
      :file-list="fileList"
      accept=".jpg, .jpeg, .png, .doc, .xls, .ppt, .docx, .xlsx, .pptx, .pdf, .txt, .bmp"
      :on-change="_onChangeAttachments"
      :on-remove="removeFile"
    >
      <!-- Caption -->
      <div class="el-upload__tip" slot="tip">
        ※レイアウト画像をアップロード出来ます(3MB以内)
      </div>

      <!-- Select file button -->
      <el-button
        size="small"
        type="default"
        :loading="loading"
        :disabled="fileList.length !== 0"
      >
        ファイルを選択
      </el-button>
    </el-upload>
  </el-form>
</template>
<script>
import FileUsecase from "@/usecases/file.usecase";

export default {
  name: "AdminOrdersImageUploader",
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    files: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      loading: false,
      fileList: [],
    };
  },
  computed: {
  },
  methods: {
    /*
    「レイアウト調整を開始する」モーダル内部でのファイルアップロード管理用のメソッド
    */
    async _onChangeAttachments (file, fileList) {
      const { raw, name } = file;

      // アップロード時のファイルサイズ制限
      // default: 3MB まで
      if (!usecase.file.validateFileSize(file)) {
        this.$refs.upload.clearFiles();

        return;
      }

      this.changeLoadingStatus(true);

      const category = "adminMessage";

      try {
        const fileName = usecase.file.fetchFileName(name, category);

        const result = await usecase.file.uploadFile(fileName, raw);

        this.fileList = fileList;

        this.updateImageFiles(result.key);
      } catch (err) {
        // Clear file list
        this.removeFile();
      } finally {
        this.changeLoadingStatus(false);
      }
    },

    async removeFile (file, fileList) {
      this.initImageFiles();
    },

    updateImageFiles (imageKey) {
      this.$emit("updateImageFile", imageKey);
    },

    /**
     * [changeLoadingStatus description]
     * @param   {[type]}  status  [status description]
     */
    changeLoadingStatus (status) {
      this.loading = status;

      this.$emit("update:isUploadingFile", status);
    },

    initImageFiles () {
      this.$refs.upload.clearFiles();
      this.fileList = [];

      // Reset: AdminOrderDetail > Data.images = []
      this.$emit("initImageFile");
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.imageUploader {
  margin-top: 2rem;

  ::v-deep .el-button {
    border: 1px solid $--border-color-base;
  }
}
</style>
